// 定義支援的語系
const SUPPORTED_LOCALES = ['en', 'zh-TW'] as const;

// 輔助函數：解析路徑中的語系
const parseLocaleFromPath = (path: string) => {
  // 移除開頭的斜線
  const pathWithoutLeadingSlash = path.replace(/^\/+/, '');

  // 匹配語系部分（確保語系後面有斜線或結尾）
  const localeMatch = pathWithoutLeadingSlash.match(/^([a-z]{2}(-[a-z]{2})?)(\/|$)/i);
  if (!localeMatch) {
    return {
      locale: null,
      pathWithoutLocale: path,
    };
  }

  const matchedLocale = localeMatch[1];
  if (!SUPPORTED_LOCALES.includes(matchedLocale as (typeof SUPPORTED_LOCALES)[number])) {
    return {
      locale: null,
      pathWithoutLocale: path,
    };
  }

  // 移除語系部分，保留剩餘路徑
  const pathWithoutLocale = pathWithoutLeadingSlash.replace(/^[a-z]{2}(-[a-z]{2})?(\/|$)/i, '');
  return {
    locale: matchedLocale,
    pathWithoutLocale: pathWithoutLocale ? `/${pathWithoutLocale}` : '/',
  };
};

export default defineNuxtRouteMiddleware((to) => {
  // 解析路徑中的語系
  const { pathWithoutLocale, locale } = parseLocaleFromPath(to.path);

  // 只在根路徑時重定向（無論是否有語言前綴），避免與其他 middleware 衝突
  // 使用 abortNavigation 來避免在 SSR 時重複設置 headers
  if (pathWithoutLocale === '/' || pathWithoutLocale === '') {
    const localePath = useLocalePath();
    const dashboardPath = localePath('/dashboard');

    // 在客戶端直接重定向
    if (import.meta.client) {
      return navigateTo(dashboardPath);
    }
    // 在伺服器端使用 abortNavigation 避免 headers 衝突
    return navigateTo(dashboardPath, { external: false });
  }
});
